<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <!-- Form Modal -->
    <b-modal id="modal-season-form" ref="myModal" centered no-close-on-backdrop no-close-on-esc size="md"
      @ok="submitBranch">
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 v-if="branch.id === null">
          Deduction Panel
        </h5>
        <h5 v-if="branch.id !== null">
          Deduction Panel
        </h5>

        <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="primary" :disabled="saving" @click="ok()">
          <b-spinner v-if="saving" small class="mr-1" label="Small Spinner" />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">
        <validation-observer ref="dataForm" #default="{ invalid }">
          <b-form ref="form" @submit.stop.prevent="handleSubmit">
            <!-- Row 1: Name and Is Optional -->
            <b-row>
              <b-col cols="6">
                <b-form-group label="Name" label-for="name">
                  <validation-provider #default="{ errors }" name="name" rules="required">
                    <b-form-input id="name" v-model="deductions.name" name="name" size="sm" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <p> Is Optional</p>
                <b-form-checkbox v-model="deductions.isOptional" name="is_optional" size="sm"
                  class="ml-3"></b-form-checkbox>
              </b-col>
            </b-row>

            <!-- Row 2: Amount and Type -->
            <b-row>
              <b-col cols="6">
                <b-form-group label="Amount" label-for="amount">
                  <validation-provider #default="{ errors }" name="amount" rules="required">
                    <b-form-input id="amount" v-model="deductions.amount" name="amount" type="number" size="sm" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Type" label-for="type">
                  <validation-provider #default="{ errors }" name="type" rules="required">
                    <b-form-select id="type" v-model="deductions.type" name="type" size="sm">
                      <b-form-select-option :value="0">
                        Value
                      </b-form-select-option>
                      <b-form-select-option :value="1">
                        Percentage
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Row 3: Description -->
            <b-row>
              <b-col cols="12">
                <b-form-group label="Description" label-for="description">
                  <validation-provider #default="{ errors }" name="description" rules="">
                    <b-form-textarea id="description" v-model="deductions.description" name="description" rows="3"
                      size="sm" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Row 4: Applies On Section -->
            <b-row>
              <b-col cols="12">
                <b-form-group label="Applies On">
                  <b-row>
                    <b-col v-for="item in deductable" :key="item.id" cols="12" md="5" class="mb-2 ml-1">
                      <b-form-checkbox :value="item.id" v-model="deductions.deductibles" name="deductibles" size="sm">
                        {{ item.name }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="6" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50 select-size-sm" />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search -->
          <b-col cols="6" md="3">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." size="sm" />
            </div>
          </b-col>

          <b-col cols="6" md="3">
            <b-button variant="outline-primary" size="sm" @click="invokeCreateForm()">
              <span class="text-nowrap">Add Deduction</span>
            </b-button>
          </b-col>
          <!-- ./Search -->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Status -->
        <template #cell(name)="data">
          <b-badge variant="light-info" v-if="data.item.description === null">
              {{ data.item.name }}
          </b-badge>
          <b-badge variant="light-danger" :title="data.item.description" v-else>
            {{ data.item.name }}
          </b-badge>
        </template>

        <template #cell(isOptional)="data">
          <b-badge variant="light-success" v-if="!data.item.isOptional">
              Yes
          </b-badge>
          <b-badge variant="light-danger" v-else>
            No
          </b-badge>
        </template>

        <template #cell(deductibles)="data">
          <b-table
            ref="records"
            striped
            hover
            small
            class="position-relative"
            :items="data.item.deductibles"
            responsive
            :fields="deductionsColumns"
            primary-key="id"
            show-empty
            empty-text=""
          >
          </b-table>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </b-card>
    <!-- ./Table Container Card -->
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody,
    BRow, BCol,
    BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem,
    BButton, BSpinner, BFormSelect, BFormSelectOption,
    BTable, BPagination, BBadge, BAvatar, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import {
    ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import banksStoreModule from '@/views/cromis/payments/deductions/deductionsStoreModule'
import useDeductionList from '@/views/cromis/payments/deductions/useDeductionsList'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'

export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BDropdown,
        BDropdownItem,
        vSelect,
        BButton,
        BSpinner,
        BFormSelect,
        BFormSelectOption,
        BTable,
        BPagination,
        BBadge,
        BAvatar,
        ValidationProvider,
        ValidationObserver,
        LocationFilters,
        BFormTextarea,
    },
    directives: {},
    props: {},
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const deductable = ref([])
        const deductionsColumns = ref([
            {key: 'name', label: ''},
        ])

        const bank = ref({
            isBank: true,
            id: null,
            name: null,
            abbreviation: null,
            branches: [],
        })

        const deductions = ref({
            name: '',
            isOptional: false,
            amount: null,
            type: 0,
            description: '',
            deductibles: [],
        })

        const branch = ref({
            isBank: false,
            id: null,
            name: null,
            code: null,
            bank_id: null,
            location_id: null,
        })

        const CROMIS_GROUP_STORE_MODULE_NAME = 'cromis-deductions'

        // Register module
        if (!store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.registerModule(CROMIS_GROUP_STORE_MODULE_NAME, banksStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_GROUP_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            // deductable list

            await store.dispatch('cromis-deductions/deductable')
                .then(response => {
                    deductable.value = response.data.deductibles
                    console.log(deductable.value)
                }).catch(error => {
                    console.log('got error', error)
                })
        })

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            myDeductions,

            // UI
            // resolveUserRoleVariant,
            // resolveUserRoleIcon,
            resolveStatusVariant,
        } = useDeductionList()

        // Form Methods
        const invokeUpdateForm = item => {
            bank.value = item
        }

        // const invokeCreateForm = () => {
        //     branch.value.isBank = false
        //     branch.value.id = null
        //     branch.value.name = null
        //     branch.value.code = null
        //     branch.value.bank_id = bank.value.id
        //     branch.value.location_id = null

        //     myModal.value.show()
        // }

        const invokeCreateForm = () => {
            deductions.value = {
                name: '',
                isOptional: false,
                amount: null,
                type: 0,
                description: '',
                deductibles: [],
            }

            myModal.value.show()
        }


        const invokeUpdateBranchForm = item => {
            branch.value.isBank = false
            branch.value.id = item.id
            branch.value.name = item.name
            branch.value.code = item.code
            branch.value.bank_id = bank.value.id
            branch.value.location_id = item.location.id

            myModal.value.show()
        }

        const changeFilter = location => {
            branch.value.location_id = location !== null ? location.id : null
        }

        const resetForm = () => {
            bank.value = {
                isBank: true,
                id: null,
                name: null,
                abbreviation: null,
                branches: [],
            }
        }

        const isFormValid = async () => {
            let isValid = false
            await datadeductions.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()
            serverErrors.value = null

            // Handle form submit
            if (bank.value.id === null || bank.value.id === 0) handleCreate()
            else handleUpdate(bank.value)
        }

        const submitBranch = async bvModalEvt => {
            bvModalEvt.preventDefault()
            serverErrors.value = null

            // Handle form submit

            await store.dispatch('cromis-deductions/create', deductions.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-bank/create', bank.value)
                .then(response => {
                    refetch()
                    saving.value = false
                    resetForm()

                    context.root.$swal({
                        icon: 'success',
                        text: `Bank ${response.data.name} has been registered successfully!`,
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    resetForm()
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-bank/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to bank ${response.data.title} has been made successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                    resetForm()
                })
                .catch(error => {
                    saving.value = false
                    resetForm()
                    console.log(error)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-bank/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: false,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        }

        return {
            // Form
            dataForm,
            saving,
            serverErrors,
            bank,
            branch,
            isFormValid,
            submit,
            submitBranch,
            handleCreate,
            invokeUpdateForm,
            invokeUpdateBranchForm,
            handleUpdate,
            remove,
            resetForm,
            deductions,
            deductable,

            // Validations
            required,

            // Table
            fetch,
            columns,
            deductionsColumns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            resolveStatusVariant,
            invokeCreateForm,
            changeFilter,
            myModal,
            myDeductions,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
